import axios from 'axios';
import config from 'config';

const api = axios.create({
  baseURL: config.baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

api.interceptors.request.use(
  async config => {
    const token = await localStorage.getItem('auth_token');

    // TODO: Adicionar verificação para endpoints que não precisam receber o token.

    if (token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error),
);
api.interceptors.response.use(config => config, error => Promise.reject(error));

export default api;
